<app-navbar title="Sprzedane wycieczki">
	<div class="form-inline text-end">
		<label class="me-2 btn btn-primary">
			Sprzedane wycieczki:
			{{ this.sum.soldTrips }}
		</label>
		<label class="me-2 btn btn-primary">
			{{ this.sum.euro }}
			€
		</label>
		<label class="me-2 btn btn-primary">
			{{ this.sum.hr }}
			HRK
		</label>
	</div>
</app-navbar>

<app-resident-sold-reservation-filters
	userFilters="reservationSold"
	[users]="parameters.users"
	(selected)="filtersSelected($event)"
></app-resident-sold-reservation-filters>

<app-dynamic-table
	[elements]="data"
	[tableRows]="tableRows"
	[haveLink]="false"
	(filtersChanged)="calculationPrice($event)"
	(filtersClicked)="filtersOpen()"
>
</app-dynamic-table>
